module.exports = __webpack_public_path__ + "static/img/mastercard.fa823dc0.svg";